import React from "react";

const Answer = ({ text }) => {
  // Split the text into points based on newline or bullet character
  const points = text
    .split(/\n|•/g)
    .map(point => point.trim())
    .filter(point => point !== "");

  return (
    <div className="bg-blue-100 p-4 rounded-lg shadow-md text-gray-800">
      {points.length > 1 ? (
        <ul className="list-disc pl-5 space-y-2">
          {points.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      ) : (
        <p>{text}</p>
      )}
    </div>
  );
};

export default Answer;
